<template>
  <div>
    <Head :title="`Order #${form.order.id}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/customers">Orders</Link>
        <span class="text-indigo-400 font-medium">/</span>
        Order #{{ form.order.id }}
      </h1>
    </div>
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
        <div class="w-full">
            <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Order INFO</h3>
            <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    #ID
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.id}}</span>
                </span>

                <Link :href="`/customers/${form.order.customer_id}/edit`" class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Customer ID
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.customer_id}}</span>

                </Link>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Brand
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.brand.id}} - {{ form.brand.name}} - {{ form.brand.domain_frontend}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Offer ID (local)
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.offer_id}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    External order ID (MGMT)
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.external_order_id}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Status
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.status}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Stage
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.stage}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Mgmt status
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.mgmt_status}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    CreatedAt
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.created_at}}</span>
                </span>

                <span class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    UpdatedAt
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ form.order.updated_at}}</span>
                </span>
            </div>
        </div>
    </div>
      <div class="max-w-full bg-white rounded-md shadow overflow-scroll mt-5">
          <div class="w-full">
              <h3 class="font-medium text-gray-900 text-center mt-5 px-6">Requests to MGMT</h3>
              <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-scroll text-sm">

                  <div class="flex flex-row font-bold text-left w-full">
                      <div class="p-[10px] w-[17%] border-r border-b border-gray-100">Method</div>
                      <div class="p-[10px] w-[58%] border-r border-b border-gray-100">Request</div>
                      <div class="p-[10px] w-[25%] border-r border-b border-gray-100">Response</div>
                  </div>
                  <div v-for="log in logs" :key="log.id" class="w-full">
                      <div class="flex flex-row font-bold text-left w-full font-normal text-[13px]">
                          <div class="p-[10px] w-[17%] border-r border-b border-gray-100">
                              {{ log.method }}<br>{{ log.created_at }}
                          </div>
                          <div class="p-[10px] w-[58%] border-r border-b border-gray-100">
                              <pre style="white-space: pre-wrap !important;">{{ log.request_payload }}</pre>
                          </div>
                          <div class="p-[10px] w-[25%] border-r border-b border-gray-100">
                              <pre style="white-space: pre-wrap !important;">{{ log.response_payload }}</pre>
                          </div>
                      </div>
                  </div>

                  <div v-if="logs.length === 0" class="w-full">
                      No request logs found.
                  </div>

<!--                  <table class="w-full whitespace-nowrap">-->
<!--                      <tr class="text-left font-bold">-->
<!--                          <th class="pb-4 pt-6 px-6">Method</th>-->
<!--                          <th class="pb-4 pt-6 px-6">Request</th>-->
<!--                          <th class="pb-4 pt-6 px-6">Response</th>-->
<!--                      </tr>-->
<!--                      <tr v-for="log in logs" :key="log.id" class="hover:bg-gray-100 focus-within:bg-gray-100">-->
<!--                          <td class="border-t">-->
<!--                              <span class="flex items-center px-6 py-4 focus:text-indigo-500">-->
<!--                                  {{ log.method }}<br>{{ log.created_at }}-->
<!--                              </span>-->
<!--                          </td>-->
<!--                          <td class="border-t">-->
<!--                              <pre class="flex items-center px-6 py-4 focus:text-indigo-500">{{ log.request_payload }}</pre>-->
<!--                          </td>-->
<!--                          <td class="border-t">-->
<!--                              <pre class="flex items-center px-6 py-4 focus:text-indigo-500">{{ log.response_payload }}</pre>-->
<!--                          </td>-->
<!--                      </tr>-->
<!--                      <tr v-if="logs.length === 0">-->
<!--                          <td class="px-6 py-4 border-t" colspan="4">No request logs found.</td>-->
<!--                      </tr>-->
<!--                  </table>-->
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
      order: Object,
      brand: Object,
      logs: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        order: this.order,
        brand: this.brand
      }),
    }
  },
  methods: {
  },
}
</script>
